export default __webpack_public_path__ + "static/media/90-day-full-body.93bc471a.jpg";